
import React from 'react';

interface StepsProps {
  steps: number;
  currentStep: number;
}

export const Steps: React.FC<StepsProps> = ({ steps, currentStep }) => {
  return (
    <div className="flex items-center justify-between">
      {Array.from({ length: steps }).map((_, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center">
            <div 
              className={`w-8 h-8 rounded-full flex items-center justify-center 
                ${index <= currentStep 
                  ? 'bg-web3-green text-background' 
                  : 'bg-muted text-muted-foreground'}`}
            >
              {index + 1}
            </div>
          </div>
          {index < steps - 1 && (
            <div className="flex-1 h-1 mx-2 bg-muted">
              <div 
                className="h-full bg-web3-green" 
                style={{ 
                  width: index < currentStep ? '100%' : '0%',
                  transition: 'width 0.3s'
                }}
              ></div>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
